export interface AuthUser {
    id: string;
    email: string;
    name?: string;
    role?: string;
    [key: string]: unknown;
}

export interface AuthState {
    token: string | null;
    user: AuthUser | null;
    permissions: unknown[];
    isAuthenticated: boolean;
    loginLoading: boolean;
    loginError: string | null;
}

export const initialAuthState: AuthState = {
    token: null,
    user: null,
    permissions: [],
    isAuthenticated: false,
    loginLoading: false,
    loginError: null,
};
